import { colorPalette } from '../../colorPalette';
export const advantage = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    width: 'fit-content',
};
export const ratingStyle = () => (Object.assign({ background: 'none', gap: '4px' }, advantage));
export const advantageText = (rating) => {
    return {
        fontStyle: 'normal',
        fontWeight: rating.size == 'sm' ? 400 : 600,
        fontSize: rating.size == 'sm' ? '1.4rem' : '1.8rem',
        lineHeight: 'normal',
        color: rating.size == 'sm' ? colorPalette.gray700 : colorPalette.gray1000,
    };
};
export const starIcon = {
    fontSize: '14px',
    color: `${colorPalette.yellow500}`,
};
export const emptyStarIcon = {
    opacity: 1,
    color: colorPalette.gray300,
};
